import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  let winners = ["314"];
  return <IndividualTable matchType={"3"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance70;
